import axios from 'axios'

const prefix = '/subscription'

export const deleteSubscription = async (type, provider) => {
  return await axios.delete(`${prefix}/web/${type}/${provider}`)
}
